export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

export const formatFileType = (type: string): string => {
  if (type.match(/^image\/.*/)) return "image";
  if (type.match(/^text\/.*/)) return "text";
  if (type === "application/pdf") return "pdf";
  if (type === "application/msword" || type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return "word";
  if (type === "application/vnd.ms-excel" || type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return "excel";
  if (type === "application/vnd.openxmlformats-officedocument.presentationml.presentation") return "powerpoint";
  if (type === "application/json") return "json";
  if (type === "application/xml") return "xml";
  return "file";
};
